































































































import { Vue, Component, Prop } from "vue-property-decorator"

@Component
export default class ResourceEntity extends Vue {
  @Prop(Boolean) protected disabled: boolean | undefined
  protected currentEntity: number = 0

  protected get item() {
    return this.$store.getters.energySources[this.currentEntity]
  }

  protected close() {
    if (this.disabled !== true) {
      this.$store.dispatch("toggleBook")
    }
  }

  protected cycle(num: number) {
    if (
      this.currentEntity + num >= 0 &&
      this.currentEntity + num <=
        this.$store.getters.energySources.length - 1 &&
      this.disabled !== true
    ) {
      this.currentEntity += num
      if (!this.$store.state.muted) {
        new Howl({
          src: ["/audio/Click.mp3"]
        }).play()
      }
    }
  }
}
